import { createSlice } from "@reduxjs/toolkit";
import { addNewRecommendation, deleteRecommendation, getRecommendationListData, updateRecommendation } from "../actions/recommendation.action";

const recommendationSlice = createSlice({
    name: "recommendation",
    initialState: {
        loading: false,
        recommendation_list: [],
        total_recommendation: 0
    },
    reducers: {},
    extraReducers: (builder) => {
        builder.addCase(getRecommendationListData.pending, (state, action) => {
            state.loading = true
        }).addCase(getRecommendationListData.fulfilled, (state, action) => {
            state.recommendation_list = action?.payload?.data?.recommendationData
            state.total_recommendation = action?.payload?.data?.totalRecords
            state.loading = false
        }).addCase(getRecommendationListData.rejected, (state, action) => {
            state.loading = false
        })
        builder.addCase(addNewRecommendation.pending, (state, action) => {
            state.loading = true
        }).addCase(addNewRecommendation.fulfilled, (state, action) => {
            state.loading = false
        }).addCase(addNewRecommendation.rejected, (state, action) => {
            state.loading = false
        })
        builder.addCase(updateRecommendation.pending, (state, action) => {
            state.loading = true
        }).addCase(updateRecommendation.fulfilled, (state, action) => {
            state.loading = false
        }).addCase(updateRecommendation.rejected, (state, action) => {
            state.loading = false
        })
        builder.addCase(deleteRecommendation.pending, (state, action) => {
            state.loading = true
        }).addCase(deleteRecommendation.fulfilled, (state, action) => {
            state.loading = false
        }).addCase(deleteRecommendation.rejected, (state, action) => {
            state.loading = false
        })
    }
})

export default recommendationSlice.reducer